import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Lock } from "lucide-react";
import useSEO from "../hooks/useSEO";

export default function AdminLogin() {
  useSEO({
    title: "Admin-Login · Caravan Reisen",
    description: "Interner Administrationsbereich von Caravan Reisen.",
    path: "/admin",
    noindex: true,
  });

  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("cr_token", r.data.access_token);
      localStorage.setItem("cr_user", JSON.stringify(r.data.user));
      nav("/admin/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Anmeldung fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-40 pb-16 max-w-md mx-auto px-6" data-testid="admin-login-page">
      <div className="bg-white rounded-3xl border border-[#D8D6D0] p-10 shadow-[0_8px_30px_rgba(27,42,34,0.06)]">
        <div className="w-12 h-12 rounded-full bg-[#1B2A22] text-white flex items-center justify-center mb-6"><Lock size={20}/></div>
        <h1 className="font-display font-bold text-3xl">Admin-Login</h1>
        <p className="mt-2 text-sm text-[#1B2A22]/70">Verwalte Fahrzeuge und Buchungen.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="label">E-Mail</label>
            <input type="email" className="input-field" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email"/>
          </div>
          <div>
            <label className="label">Passwort</label>
            <input type="password" className="input-field" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password"/>
          </div>
          {error && <div className="text-sm text-[#C05C42]" data-testid="admin-error">{error}</div>}
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-submit">
            {loading ? "Anmelden..." : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}
